import { AsertoNameValidator } from '@aserto/console-common'

const ConnectionNameValidator = AsertoNameValidator

export default ConnectionNameValidator
